import { render, staticRenderFns } from "./smtpConfiguration.vue?vue&type=template&id=26990d9d&scoped=true"
import script from "./smtpConfiguration.vue?vue&type=script&lang=js"
export * from "./smtpConfiguration.vue?vue&type=script&lang=js"
import style0 from "./smtpConfiguration.vue?vue&type=style&index=0&id=26990d9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26990d9d",
  null
  
)

export default component.exports